(function Index($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('/Main/index/', function onload()
		{
			$('.client-select').on('change', function _selectClient(e) {
				var client_id = $(this).find('option:selected').data('client-id');

				if (client_id === undefined || client_id === '') {
					document.location.href = HE.base_uri + '/Main/index/';
				} else {
					document.location.href = HE.base_uri + '/Main/index/' + client_id;
				}
			});

			loadProviderSales();
			loadBookingInsights();

			loadProviderSalesSTLY();
			loadBookingInsightsSTLY();
		});

		$('#booking-insights, #booking-insights-stly').on('click', '#booking-insights-submit', function _filterProviderSales() {
			var start_date = $('#booking-insights-start-date').val(),
				end_date   = $('#booking-insights-end-date').val(),
				stly       = $(this).data('stly');

			if (stly === true) {
				start_date = $('#booking-insights-start-date[data-stly="true"]').val();
				end_date   = $('#booking-insights-end-date[data-stly="true"]').val();
			} else {
				start_date = $('#booking-insights-start-date[data-stly=""]').val();
				end_date   = $('#booking-insights-end-date[data-stly=""]').val();
			}
			
			if (new Date(start_date) > new Date(end_date)) {
				HE.StatusMessage('error', 'Start date cannot be after end date');
				return;
			}

			if (stly === true) {
				loadBookingInsightsSTLY(start_date, end_date);
			} else {
				loadBookingInsights(start_date, end_date);
			}
		});

		$('#booking-insights, #booking-insights-stly').on('click', '.booking-insights-filter-dates', function _filterDates(e) {
			var start_date = $(this).data('start'),
				end_date   = $(this).data('end'),
				stly       = $(this).data('stly');

			e.preventDefault();

			$('#booking-insights-start-date').val(start_date);
			$('#booking-insights-end-date').val(end_date);

			if (stly === true) {
				loadBookingInsightsSTLY(start_date, end_date);
			} else {
				loadBookingInsights(start_date, end_date);
			}
		});

		$('#provider-sales, #provider-sales-stly').on('click', '#provider-sales-submit', function _filterProviderSales() {
			var start_date,
				end_date,
				stly = $(this).data('stly');

			if (stly === true) {
				start_date = $('#provider-sales-start-date[data-stly="true"]').val();
				end_date   = $('#provider-sales-end-date[data-stly="true"]').val();
			} else {
				start_date = $('#provider-sales-start-date[data-stly=""]').val();
				end_date   = $('#provider-sales-end-date[data-stly=""]').val();
			}

			// Check if end date is before start date
			if (new Date(start_date) > new Date(end_date)) {
				HE.StatusMessage('error', 'Start date cannot be after end date');
				return;
			}

			if (stly === true) {
				loadProviderSalesSTLY(start_date, end_date);
			} else {
				loadProviderSales(start_date, end_date);
			}
		});

		$('#provider-sales, #provider-sales-stly').on('click', '.provider-sales-filter-dates', function _filterDates(e) {
			var start_date = $(this).data('start'),
				end_date   = $(this).data('end'),
				stly       = $(this).data('stly');

			e.preventDefault();

			$('#provider-sales-start-date').val(start_date);
			$('#provider-sales-end-date').val(end_date);

			if (stly === true) {
				loadProviderSalesSTLY(start_date, end_date);
			} else {
				loadProviderSales(start_date, end_date);
			}
		});
	});

	function loadBookingInsights(start_date, end_date) {
		start_date = start_date || ''; // eslint-disable-line no-param-reassign
		end_date   = end_date || ''; // eslint-disable-line no-param-reassign

		$('#booking-insights').html("<div class='text-center'><i class='fa fa-spinner fa-spin fa-2x'></i> Loading...</div>");

		HE.Ajax.get('/Main/bookingInsights/' + start_date + '/' + end_date).then(function _success(response) {
			$('#booking-insights').html(response);
		});
	}

	function loadBookingInsightsSTLY(start_date, end_date) {
		start_date = start_date || ''; // eslint-disable-line no-param-reassign
		end_date   = end_date || ''; // eslint-disable-line no-param-reassign

		$('#booking-insights-stly').html("<div class='text-center'><i class='fa fa-spinner fa-spin fa-2x'></i> Loading...</div>");

		HE.Ajax.get('/Main/bookingInsights/' + start_date + '/' + end_date + '/true').then(function _success(response) {
			$('#booking-insights-stly').html(response);
		});
	}

	function loadProviderSales(start_date, end_date) {
		start_date = start_date || ''; // eslint-disable-line no-param-reassign
		end_date   = end_date || ''; // eslint-disable-line no-param-reassign

		$('#provider-sales').html("<div class='text-center'><i class='fa fa-spinner fa-spin fa-2x'></i> Loading...</div>");

		HE.Ajax.get('/Main/providerSales/' + start_date + '/' + end_date).then(function _success(response) {
			$('#provider-sales').html(response);
		});
	}

	function loadProviderSalesSTLY(start_date, end_date) {
		start_date = start_date || ''; // eslint-disable-line no-param-reassign
		end_date   = end_date || ''; // eslint-disable-line no-param-reassign

		$('#provider-sales-stly').html("<div class='text-center'><i class='fa fa-spinner fa-spin fa-2x'></i> Loading...</div>");

		HE.Ajax.get('/Main/providerSales/' + start_date + '/' + end_date + '/true').then(function _success(response) {
			$('#provider-sales-stly').html(response);
		});
	}
}(jQuery, window.HE || {}));
